import client from '../httpClient';

/**
 * @param {{responsibilities:{
 *          userId: number,
 *          lastOperationDay: string,
 *          operationTime?: number}[]}} params,
 */
const holidayPutOperationTimeApi = (params) => {
  const PUT_HOLIDAY_OPERATION_TIME_URL = '/holiday/operation/time';
  return client.put(
    PUT_HOLIDAY_OPERATION_TIME_URL,
    JSON.stringify(params),
    { isShowLoading: false },
  );
};

export default holidayPutOperationTimeApi;
